import { render, staticRenderFns } from "./QuizStatics.vue?vue&type=template&id=50950d54&scoped=true&"
import script from "./QuizStatics.vue?vue&type=script&lang=js&"
export * from "./QuizStatics.vue?vue&type=script&lang=js&"
import style0 from "./QuizStatics.vue?vue&type=style&index=0&id=50950d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50950d54",
  null
  
)

export default component.exports